export const config = {
  nuwiq: {
    limit: '$12,000',
    phone: 'the Factor My Way Support Center at 855-498-4260.',
  },
  wilate: {
    limit: '$12,000',
    phone: 'the Factor My Way Support Center at 855-498-4260.',
  },
  fibryga: {
    limit: '$2,500',
    phone: 'The Octapharma Patient Support Center at 800-554-4440.',
  },
  cutaquig: {
    limit: '$12,500',
    phone: 'please call the IgCares Support Line at 833-382-7686.',
  },
  octagam: {
    limit: '$12,500',
    phone: 'the Octapharma Patient Support Line at 800-554-4440.',
  },
  panzyga: {
    limit: '$12,500',
    phone: 'the Octapharma Patient Support Line at 800-554-4440.',
  },
};
